import { Strings } from '../assets/res/en'
export default function emailsDataColumn() {
    const emailCols = [
        { title: Strings.EMAIL_TEXT, field: 'emailValue', validate: rowData => (rowData.emailValue && rowData.emailValue.match(/^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/i)) ? true : false  },
        { title: Strings.PREFFERED, field: 'preferred', type: 'boolean' }
    ]
    return { emailCols }
}